import { memo, useState } from 'react';
import { Page } from '../Layout/Page/Page';
import { useLocalization } from '../../context/Localization/localization';
import { ScrollableBody } from '../Layout/ScrollableBody';
import { useKioskDispatch, useMonochromeTheme, useNoAnimations } from '../../context/Kiosk/kiosk';
import { IconButton } from '../../controls/IconButton/IconButton';
import { useNavigate } from 'react-router-dom';
import { CTAButton } from '../../controls/ButtonBase';
import { KioskDispatchTypes } from '../../context/Kiosk/kiosk.types';
import { GMButtonGroup } from '../../controls/ButtonGroup';
import { GMSizedIcon } from '../../controls/Icon';
import { GMFormCheckbox } from '../../controls/Checkbox';

export const AccessibilityDialog = memo(() => {
    const monochromeTheme = useMonochromeTheme();
    const noAnimations = useNoAnimations();
    const dispatch = useKioskDispatch();
    const Localization = useLocalization();
    const navigate = useNavigate();
    const [monochromeChecked, setMonochromeChecked] = useState<boolean>(monochromeTheme);
    const [noAnimationsChecked, setNoAnimationsChecked] = useState<boolean>(noAnimations);

    return (
        <Page
            customHeaderProps={{
                title: Localization.AccessibilityControlPanel,
                rightIcons: [
                    <IconButton
                        key={'accessibility-control-panel-close'}
                        sizedIcon={
                            <GMSizedIcon
                                iconType={'Close'}
                                iconSize={'medium'}
                                ariaLabel={Localization.CloseIcon}
                                title={Localization.ClickToCloseWindow}
                            />
                        }
                        onClick={() => navigate(-1)}
                        ariaLabel={Localization.ClickToCloseWindow}
                        id={Localization.ClickToCloseWindow}
                    />,
                ],
            }}
            showKioskBanner={false}
        >
            <ScrollableBody>
                <h2>{Localization.SelectSiteAppearance}</h2>
                <div>
                    <GMFormCheckbox
                        label={Localization.ColorSensitiveAppearance}
                        checked={monochromeChecked}
                        onChange={() => setMonochromeChecked(!monochromeChecked)}
                    />
                </div>
                <div>
                    <GMFormCheckbox
                        label={Localization.StopSiteAnimations}
                        checked={noAnimationsChecked}
                        onChange={() => setNoAnimationsChecked(!noAnimationsChecked)}
                    />
                </div>
            </ScrollableBody>
            <GMButtonGroup
                buttons={[
                    <CTAButton
                        label={Localization.UpdateSite}
                        styleType={'primary'}
                        onClick={() => {
                            if (monochromeTheme !== monochromeChecked) {
                                dispatch({ type: monochromeChecked ? KioskDispatchTypes.SetMonochromeTheme : KioskDispatchTypes.ClearMonochromeTheme });
                            }
                            if (noAnimations !== noAnimationsChecked) {
                                dispatch({ type: noAnimationsChecked ? KioskDispatchTypes.SetNoAnimations : KioskDispatchTypes.ClearNoAnimations });
                            }
                            navigate(-1);
                        }}
                        id={Localization.UpdateSite}
                        ariaLabel={Localization.UpdateSite}
                    />,
                ]}
            />
        </Page>
    );
});
